import { render, staticRenderFns } from "./ViewShipmentDetails.vue?vue&type=template&id=464a4ce8&scoped=true"
import script from "./ViewShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ViewShipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewShipmentDetails.vue?vue&type=style&index=0&id=464a4ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a4ce8",
  null
  
)

export default component.exports